export class StaticContentClient {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }

    /**
     *
     * @param {String} token - keycloak token
     */
    getRequestHeaders = token => (token ? { authorization: `Bearer ${token}` } : {});

    /**
     * Get assessment-speciffic reminders content for all measures
     * @param {String} token - keycloak token for API authorization
     * @returns {Promise}
     */
    async getReminders(token = '') {
        const headers = this.getRequestHeaders(token);
        return this.httpClient.get(this.constructor.REMINDERS_URL, {
            headers,
        });
    }

    /**
     * Get assessment-speciffic instructions content for all measures
     * @param {String} token - keycloak token for API authorization
     * @returns {Promise}
     */
    async getInstructions(token = '') {
        const headers = this.getRequestHeaders(token);
        return this.httpClient.get(this.constructor.INSTRUCTIONS_URL, {
            headers,
        });
    }
}

export default StaticContentClient;
